import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import { getTranscriptDataApi } from "../../api";
import { Popover } from "antd";
import "../../styles/transcript.css";
import Footer from "../Footer";
import TranscriptCardSection from "./TranscriptCardSection";
import TranscriptNavbar from "./TranscriptNavbar";

function TranscriptMainPage({ auth, interviewId, interviewType }) {
  const [loading, setLoading] = useState(false);
  const [conversationHistory, setConversationHistory] = useState(null);
  const [config, setConfig] = useState(null);
  const [interviewAnalysisDataConfig, setInterviewAnalysisDataConfig] =
    useState(null);

  const getTranscriptData = async () => {
    const url = `${getTranscriptDataApi}?interviewId=${interviewId}&interviewType=${interviewType}`;

    try {
      setLoading(true);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        setConversationHistory(result.data.interviewHistory);
        setInterviewAnalysisDataConfig(result.data.reportBasicData);
        setConfig(result.data.reportBasicData.configuration);
      }
    } catch (err) {
      setLoading(false);
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTranscriptData();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="bg-white min-h-screen flex flex-col">
        <TranscriptNavbar config={config} />
        <TranscriptCardSection interviewData={interviewAnalysisDataConfig} />
        {conversationHistory && conversationHistory.length > 0 && (
          <div className="button-chat-container">
            <button onClick={() => window.print()} className="print-button top-[11%] min-[540px]:top-[2%]">
              <span className="md:block hidden">Print Transcript</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </span>
            </button>
          </div>
        )}
        <div className="transcript-chat-container flex flex-col gap-[.8rem] w-[96%] lg:w-[90%] xl:w-[80%] m-auto px-3 py-7">
          {conversationHistory && conversationHistory.length > 0 ? (
            conversationHistory.map((conversation) => {
              return (
                <>
                  {conversation.role === "Maya" ? (
                    <div className="flex justify-start items-start gap-2">
                      <div className="profileCircle">
                        <Popover
                          placement="right"
                          className="circle"
                          content={conversation.role}
                          overlayStyle={{
                            borderRadius: "8px",
                            padding: 0,
                          }}
                          overlayInnerStyle={{ padding: 6 }}
                        >
                          <div className="bg-[#103662] circle">
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.5992 11.3091C18.7272 11.7657 19.1412 12.1014 19.6319 12.1014C20.2243 12.1014 20.7063 11.6126 20.7063 11.0118C20.7063 10.411 20.2243 9.92232 19.6319 9.92232C19.1412 9.92232 18.7272 10.258 18.5992 10.7145H10.9819V2.7528C10.9819 1.23488 9.76417 0 8.26729 0C7.13842 0 6.14907 0.690595 5.74234 1.73964C5.69357 1.73702 5.64463 1.73568 5.59548 1.73568C4.0986 1.73568 2.88092 2.97056 2.88092 4.48848C2.88092 4.6048 2.88808 4.72073 2.9024 4.83563C2.20525 4.94739 1.54077 5.29793 1.00299 5.84337C0.356137 6.49925 0 7.3713 0 8.29887C0 9.2264 0.356264 10.0984 1.00299 10.7544C1.08841 10.841 1.17896 10.9229 1.27421 11C1.17909 11.0769 1.08841 11.1589 1.00299 11.2456C-0.332197 12.5996 -0.332197 14.8026 1.00299 16.1566C1.54086 16.7021 2.20534 17.0526 2.9024 17.1644C2.88808 17.2792 2.88092 17.3952 2.88092 17.5115C2.88092 19.0295 4.09865 20.2643 5.59548 20.2643C5.64463 20.2643 5.69357 20.2629 5.74234 20.2604C6.14907 21.3094 7.13842 22 8.26729 22C9.76417 22 10.9819 20.7651 10.9819 19.2472V11.3091H18.5992ZM19.6319 10.5169C19.901 10.5169 20.1199 10.7389 20.1199 11.0118C20.1199 11.2847 19.901 11.5068 19.6319 11.5068C19.3628 11.5068 19.1439 11.2847 19.1439 11.0118C19.1439 10.7389 19.3628 10.5169 19.6319 10.5169ZM0.586344 8.29887C0.586344 7.53007 0.881508 6.80734 1.41756 6.26374C1.93543 5.73849 2.58838 5.43053 3.2568 5.39525C3.76221 5.39663 4.24801 5.5325 4.67779 5.7888C4.59864 5.94057 4.5533 6.11313 4.5533 6.29644C4.5533 6.89723 5.03532 7.38596 5.62777 7.38596C6.22021 7.38596 6.70224 6.89723 6.70224 6.29644C6.70224 5.69565 6.22021 5.20683 5.62777 5.20683C5.43358 5.20683 5.25176 5.26012 5.09439 5.3519C4.61211 5.03646 4.06619 4.85079 3.4934 4.80993C3.47773 4.70363 3.4673 4.59651 3.4673 4.48844C3.4673 3.29837 4.42203 2.33024 5.59552 2.33024C6.052 2.33024 6.49258 2.47831 6.85656 2.75009C6.76368 2.91118 6.70953 3.09792 6.70953 3.2976C6.70953 3.89839 7.19155 4.38712 7.784 4.38712C8.37644 4.38712 8.85847 3.89839 8.85847 3.2976C8.85847 2.69681 8.3764 2.20817 7.78395 2.20817C7.60209 2.20817 7.43087 2.25457 7.28057 2.33579C6.99876 2.10878 6.67974 1.93871 6.3375 1.84023C6.68241 1.08449 7.42532 0.594603 8.26733 0.594603C9.44087 0.594603 10.3956 1.56278 10.3956 2.7528V10.7027H1.87085C1.70564 10.5956 1.55344 10.4718 1.41756 10.334C0.881508 9.79041 0.586344 9.06758 0.586344 8.29887ZM5.62773 5.80148C5.89683 5.80148 6.11585 6.02359 6.11585 6.29648C6.11585 6.56938 5.89683 6.7914 5.62773 6.7914C5.35862 6.7914 5.1396 6.56938 5.1396 6.29648C5.1396 6.02359 5.35862 5.80148 5.62773 5.80148ZM7.78395 2.80273C8.05306 2.80273 8.27208 3.02475 8.27208 3.29764C8.27208 3.57054 8.05306 3.79256 7.78395 3.79256C7.51485 3.79256 7.29583 3.57054 7.29583 3.29764C7.29583 3.02475 7.51481 2.80273 7.78395 2.80273ZM10.3956 19.2472C10.3956 20.4373 9.44083 21.4054 8.26733 21.4054C7.42532 21.4054 6.68241 20.9156 6.3375 20.1598C6.6577 20.0677 6.95787 19.9133 7.22625 19.7083C7.38905 19.8091 7.57959 19.8683 7.78395 19.8683C8.3764 19.8683 8.85842 19.3795 8.85842 18.7787C8.85842 18.1779 8.3764 17.6892 7.78395 17.6892C7.19151 17.6892 6.70948 18.1779 6.70948 18.7787C6.70948 18.9557 6.75224 19.1225 6.82643 19.2704C6.46822 19.5285 6.03967 19.6698 5.59548 19.6698C4.42195 19.6698 3.46726 18.7016 3.46726 17.5116C3.46726 17.4035 3.47768 17.2964 3.49336 17.1901C4.07945 17.1483 4.63732 16.9546 5.12774 16.6256C5.27727 16.7057 5.44726 16.7516 5.62777 16.7516C6.22021 16.7516 6.70224 16.2628 6.70224 15.6621C6.70224 15.0613 6.22021 14.5725 5.62777 14.5725C5.03532 14.5725 4.5533 15.0613 4.5533 15.6621C4.5533 15.8583 4.60546 16.0421 4.69533 16.2013C4.26131 16.4643 3.76903 16.6034 3.2568 16.6047C2.58846 16.5695 1.93555 16.2615 1.41756 15.7363C0.881508 15.1927 0.586344 14.4698 0.586344 13.7011C0.586344 12.9323 0.881508 12.2096 1.41756 11.666C1.55366 11.528 1.70586 11.4042 1.87085 11.2973H10.3956V19.2472ZM7.29583 18.7788C7.29583 18.5059 7.51485 18.2838 7.78395 18.2838C8.05306 18.2838 8.27208 18.5059 8.27208 18.7788C8.27208 19.0517 8.05306 19.2738 7.78395 19.2738C7.51481 19.2738 7.29583 19.0517 7.29583 18.7788ZM5.1396 15.6621C5.1396 15.3892 5.35862 15.1671 5.62773 15.1671C5.89683 15.1671 6.11585 15.3892 6.11585 15.6621C6.11585 15.9349 5.89683 16.157 5.62773 16.157C5.35862 16.157 5.1396 15.9349 5.1396 15.6621ZM11.7982 5.53086H15.9255C16.0285 5.53086 16.1238 5.47608 16.1768 5.38649L17.7169 2.78365C17.7983 2.80372 17.8828 2.81553 17.9702 2.81553C18.5627 2.81553 19.0446 2.32681 19.0446 1.72602C19.0446 1.12522 18.5627 0.636411 17.9702 0.636411C17.3778 0.636411 16.8957 1.12522 16.8957 1.72602C16.8957 2.024 17.0145 2.29419 17.2063 2.49108L15.7595 4.9363H11.7983C11.6364 4.9363 11.5051 5.06938 11.5051 5.2336C11.5051 5.39783 11.6364 5.53086 11.7982 5.53086ZM17.9702 1.23101C18.2393 1.23101 18.4583 1.45312 18.4583 1.72602C18.4583 1.99891 18.2393 2.22093 17.9702 2.22093C17.7009 2.22093 17.482 1.99891 17.482 1.72602C17.482 1.45312 17.7009 1.23101 17.9702 1.23101ZM19.0403 6.66524L17.9859 7.94846H12.9102C12.7483 7.94846 12.617 8.08154 12.617 8.24576C12.617 8.40999 12.7483 8.54306 12.9102 8.54306H18.1231C18.2101 8.54306 18.2926 8.50388 18.3483 8.43611L19.4916 7.045C19.6244 7.10481 19.7711 7.13871 19.9256 7.13871C20.5181 7.13871 21 6.64999 21 6.0492C21 5.44841 20.5181 4.95959 19.9256 4.95959C19.3332 4.95959 18.8512 5.44841 18.8512 6.0492C18.8512 6.27775 18.9213 6.48984 19.0403 6.66524ZM19.9256 5.55419C20.1947 5.55419 20.4137 5.7763 20.4137 6.0492C20.4137 6.32209 20.1947 6.54411 19.9256 6.54411C19.6565 6.54411 19.4376 6.32209 19.4376 6.0492C19.4376 5.7763 19.6565 5.55419 19.9256 5.55419ZM19.9256 14.7412C19.7378 14.7412 19.5613 14.7906 19.4075 14.8769L18.3483 13.5881C18.2926 13.5203 18.2101 13.4811 18.1231 13.4811H12.9102C12.7483 13.4811 12.617 13.6142 12.617 13.7784C12.617 13.9427 12.7483 14.0757 12.9102 14.0757H17.9859L18.9898 15.2974C18.902 15.4552 18.8512 15.637 18.8512 15.8308C18.8512 16.4316 19.3332 16.9204 19.9256 16.9204C20.5181 16.9204 21 16.4316 21 15.8308C21 15.23 20.5181 14.7412 19.9256 14.7412ZM19.9256 16.3258C19.6565 16.3258 19.4376 16.1037 19.4376 15.8308C19.4376 15.5579 19.6565 15.3358 19.9256 15.3358C20.1947 15.3358 20.4137 15.5579 20.4137 15.8308C20.4137 16.1037 20.1948 16.3258 19.9256 16.3258ZM17.9702 19.2408C17.8888 19.2408 17.8097 19.2509 17.7334 19.2684L16.1768 16.6375C16.1238 16.5479 16.0285 16.4932 15.9255 16.4932H11.7982C11.6364 16.4932 11.5051 16.6262 11.5051 16.7905C11.5051 16.9547 11.6364 17.0878 11.7982 17.0878H15.7594L17.2183 19.5534C17.0195 19.7513 16.8957 20.0264 16.8957 20.3304C16.8957 20.9312 17.3778 21.42 17.9702 21.42C18.5627 21.42 19.0446 20.9312 19.0446 20.3304C19.0446 19.7297 18.5627 19.2408 17.9702 19.2408ZM17.9702 20.8254C17.7009 20.8254 17.482 20.6033 17.482 20.3304C17.482 20.0576 17.7009 19.8354 17.9702 19.8354C18.2393 19.8354 18.4583 20.0576 18.4583 20.3304C18.4583 20.6033 18.2393 20.8254 17.9702 20.8254Z"
                                fill="#FCFCFD"
                              />
                            </svg>
                          </div>
                        </Popover>
                      </div>

                      <div className="flex flex-col gap-1">
                        <div className="text-left text-[.82rem]">
                          <div className="font-medium">{conversation.role}</div>
                        </div>
                        <div className="bg-[#EAECF0] bubble-left">
                          {conversation.content}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-end items-start gap-2">
                      <div className="flex flex-col gap-1">
                        <div className="text-right text-[.82rem]">
                          <div className="font-medium">{conversation.role}</div>
                        </div>
                        <div className=" bg-[#D4E7FD] bubble-right">
                          {conversation.content}
                        </div>
                      </div>
                      <div className="profileCircle">
                        <Popover
                          placement="right"
                          className="circle"
                          content={conversation.role}
                          overlayStyle={{
                            borderRadius: "8px",
                            padding: 0,
                          }}
                          overlayInnerStyle={{ padding: 6 }}
                        >
                          <div className="bg-[#963D52] circle">
                            {conversation.role.charAt(0)}
                          </div>
                        </Popover>
                      </div>
                    </div>
                  )}
                </>
              );
            })
          ) : (
            <div className="text-[1.15rem] font-medium text-center my-6 text-slate-500">
              No transcript found...
            </div>
          )}
        </div>
        <div className="px-3 lg:px-6 py-3 justify-self-end">
          <Footer emailColor="#101828" />
        </div>
      </div>
    </>
  );
}

export default TranscriptMainPage;
